import { render, staticRenderFns } from "./ModalProcesso.vue?vue&type=template&id=48d44d4d&scoped=true&"
import script from "./ModalProcesso.vue?vue&type=script&lang=js&"
export * from "./ModalProcesso.vue?vue&type=script&lang=js&"
import style0 from "./ModalProcesso.vue?vue&type=style&index=0&id=48d44d4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d44d4d",
  null
  
)

export default component.exports